//
// Level.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import EventDispatcher from "../../../events/EventDispatcher";
import "../../../lib";
import "../dataset/DataType";
import "../DataValue";

var Level = createModule("commons::Level", [], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getFormatName: [7],
        getName: [7],
        getLabel: [7],
        getCurrentDisplayString: [7],
        getCurrentValue: [1],
        getDataType: [4],
        isDateTime: [2],
        getFormattedCurrentValue: [7],
        setCurrentValue: [0,1],
        isDrillable: [2],
    },
    {
        _create: [4,7,7,7,4,2,1],
    },
    ,
]);
export default Level;
